import { Auth } from "aws-amplify";
import { call, delay, put } from "redux-saga/effects";

import { MiniMessageBox } from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzResendSignUpCode(email_address: string): Generator<any, any, any> {
  return yield Auth.resendSignUp(email_address);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzResendCodeWorker({ payload }: Record<string, any>): Generator<any, any, any> {
  try {
    const { email } = payload;

    yield call(authnzResendSignUpCode, email);

    yield put(
      MiniMessageBox.showMiniBoxMessage({
        show: true,
        type: "success",
        message: `Another code has been sent to ${email}.`,
      }),
    );

    yield delay(7000);

    yield put(MiniMessageBox.hideMiniBoxMessage());
  } catch (error) {
    if (error instanceof Error) {
      yield put(
        MiniMessageBox.showMiniBoxMessage({
          show: true,
          type: "error",
          message: error.message,
        }),
      );
    }
  }
}
